

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/checkout/index');

var _index2 = require('xo-models/src/fi/index');

var _auth = require('xo-models/src/auth');

var _index3 = require('xo-models/src/thirdPartyWallet/index');

var _thirdPartyInfo = require('xo-third-party-components/src/thirdParty-info');

require('xo-form-components/src/select-shipping-country/directive');

require('xo-address-components/src/add-address/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-ui-components/src/message/directive');

require('xo-form-components/src/phone/phoneInput/directive');

require('xo-form-components/src/emailInput/directive');

require('xo-form-components/src/name-input/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoThirdPartyInfoFlowComponent', {
    tag: 'xo-third-party-info-collect',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        }
    },

    resolve: {
        models: function models() {
            return {
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                checkoutPayee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()
            };
        },
        payloadId: function payloadId() {
            return {
                payload_id: _uiRouter.$stateParams['payload_id']
            };
        }
    },

    actions: {
        handleFormValidation: function handleFormValidation(res) {
            var $el = $(this.$element);

            if (res && res.fields && res.fields.length) {
                res.fields.forEach(function (field) {
                    if (field.field) {
                        var $field = $($el.find('[name="' + field.field + '"]'));

                        if ($field.length === 0 && field.field === 'zip') {
                            $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                        }
                        $field.addClass('backendError');
                        $field.attr('aria-invalid', true);
                    }
                });
            }

            $el.find('form').find('.backendError, .ng-invalid').first().focus();
        },
        onSubmit: function onSubmit() {
            var _this = this;

            var createCheckoutSession = function createCheckoutSession() {
                var checkoutSessionModel = _index.$CheckoutSessionModel.instance(_this.token);

                return checkoutSessionModel.action('create', {
                    data: {
                        fraudnet_id: _this.models.cart.supplementary && _this.models.cart.supplementary.risk_correlation_id,
                        user_selected_funding_source: {
                            product_name: 'BAIDU'
                        },
                        is_skip_gfo: true
                    },
                    success: function success() {
                        return _uiRouter.$state.go('checkout.review');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('SYMPHONY CONTINGENCY', msg);
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }

                });
            };

            var refreshAuthState = function refreshAuthState() {
                var auth = _auth.$AuthModel.instance().reload();

                _squid.$locale.choose(auth.country, auth.language, false);
                return auth;
            };

            var onAuth = function onAuth(authModel) {

                if (window.xprops && window.xprops.onAuth && authModel && authModel.access_token) {

                    return window.xprops.onAuth({
                        accessToken: authModel.access_token
                    });
                }
            };

            var phone = this.buyerInfo.phone.telephone;

            phone = phone.replace(/\(|\)|\s|\-/g, ''); // removing parenthesis, commas, and dashes from the phone #

            var onboardRequest = {
                payload_id: this.buyerInfo.payload_id,
                phone: _extends({}, this.buyerInfo.phone, { telephone: phone }),
                email: this.buyerInfo.user.email,
                address: this.buyerInfo.address
            };

            var onboardMember = function onboardMember() {
                var thirdPartyModel = _index3.$ThirdPartyOnboard.instance(_this.token);

                return thirdPartyModel.action('onboard', {
                    data: onboardRequest,
                    success: function success(data) {
                        _logger.$logger.info('baidu_onboard_success');
                    },
                    error: function error(err) {
                        _logger.$logger.info('baidu_onboard_error: ', err);

                        _logger.$logger.info('checkout_fpti', {
                            from: 'third_party_info_collect',
                            to: 'process_third_party_info_collect',
                            'int_error_description': 'baidu_onboard_failure',
                            'error_type': 'soft_decline',
                            'error_source': 'hermesnodeweb'
                        });
                        _uiRouter.$state.go('checkout.login', { baiduError: true });
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('THIS IS ONBOARD CONTINGENCY: ', msg);

                            _logger.$logger.info('checkout_fpti', {
                                from: 'third_party_info_collect',
                                to: 'process_third_party_info_collect',
                                'int_error_description': msg,
                                'error_type': 'soft_decline',
                                'error_source': 'hermesnodeweb'
                            });
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }
                });
            };

            var setBaiduExperience = function setBaiduExperience() {
                return _thirdPartyInfo.thirdPartyExperience.setAsBaiduExperience(_this.token);
            };

            var addressValidation = new _index2.$BillingAddressModel({
                line1: this.buyerInfo.address.line1,
                line2: this.buyerInfo.address.line2,
                city: this.buyerInfo.address.city,
                state: this.buyerInfo.address.state,
                postal_code: this.buyerInfo.address.postal_code,
                country: this.buyerInfo.address.country,
                id: '0'
            });

            addressValidation.save({
                success: function success() {
                    onboardMember().then(refreshAuthState).then(onAuth).then(setBaiduExperience).then(createCheckoutSession);
                },
                validation: function validation(res) {
                    _this.actions.handleFormValidation(res);
                },
                error: function error() {
                    console.log('address_validation_error');
                }
            });
        }
    },

    lifecycle: {
        enter: function enter() {
            this.buyerInfo = {
                address: {
                    country: _squid.$locale.country
                },
                user: {},
                phone: {}
            };
        },
        populate: function populate() {
            var payloadId = this.payloadId,
                cart = this.models.cart;


            var phone = cart.get('purchase.phone_fields.shipping_phone_number');
            var email = cart.get('payer.email');
            var shipping_address = cart.get('purchase.shipping_address');

            if (shipping_address) {
                shipping_address.country = shipping_address.country_code ? shipping_address.country_code : this.buyerInfo.address.country;
                shipping_address.country = shipping_address.country === 'CN' ? 'C2' : shipping_address.country;
                this.buyerInfo.address = shipping_address;
            }

            if (email) {
                this.buyerInfo.user.email = email;
            }

            if (phone) {
                this.buyerInfo.phone.telephone = phone;
            }

            this.buyerInfo.payload_id = payloadId.payload_id;
        }
    }
});


_squid.$Component;

_squid.$locale;

_uiRouter.$stateParams;

_uiRouter.$state;

_logger.$logger;

_index.$CheckoutPayeeModel;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_index2.$BillingAddressModel;

_auth.$AuthModel;

_index3.$ThirdPartyOnboard;

_thirdPartyInfo.thirdPartyExperience;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-third-party-info/directive.js
// module id = ./pages/xo-third-party-info/directive.js
// module chunks = 0